<template>
     
  <div class="container-fluid">
    <b-row>
      <b-col
        sm="12"
        class="text-right my-1"
      >
      <locale />
      </b-col>
    </b-row>

    <b-row class="d-flex justify-content-center pt-1">
       <b-col
        sm='12'
        class="text-center pb-1"
      >
      <b-link class="brand-logo" @click.prevent="loginRoute()">
        <img class="img_logo" :src="logo" alt="logo">
      </b-link>
      </b-col>
    </b-row>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{ $t('message.notpermission') }} 🔐
        </h2>
        <p class="mb-2">
          {{ $t('message.loginauthorized') }}
        </p>
        <b-button
          variant="primary"
          class="mb-1 btn-sm-block"
          @click="loginRoute()"
        >{{ $t('message.returnlogin') }}</b-button>
        <b-img
          class="imgFluid"
          :src="imgUrl"
          alt="Not authorized page"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg, BButton, BRow, BCol } from 'bootstrap-vue'
import store from '@/store/index'
import { performLogoutWithoutRedirect } from '@/auth/logout'
import Locale from '@/views/pages/components/Locale.vue'

export default {
  components: {
    BLink, BImg, BButton, BRow, BCol, Locale
  },
  data() {
    return {
      logo: require('@/assets/images/quotation/sft_logo.svg'),
      downImg: require('@/assets/images/pages/not-authorized.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: {
    loginRoute() {
      performLogoutWithoutRedirect(this.$store);
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
.img_logo {
  display: inline-block;
  margin: 0 auto;
  max-width: 650px;
  width: 80%;
  height: auto;
}
.imgFluid {
  display: block;
  margin: 0 auto;
  max-width: 100%; 
  height: auto;
}
</style>
